module.exports = __webpack_public_path__ + "static/media/tram.7f27a720.svg";